module.exports = __webpack_public_path__ + "static/media/blrss1.4bc84b5e.png";